import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleVesselCommercialExempt } from '../../redux/modules/registration';
import TextInput from '../../components/TextInput';

class CommercialVesselFee extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.toggleVesselCommercialExempt();
  }

  render() {
    const { vesselCommercialExempt, vesselCommercialFee } = this.props;
    return (
      <div className="Row Registration-vesselCommercialFee" style={{ display: this.props.vesselShowExemptFee ? 'block' : 'none' }}>
        <TextInput tabIndex="-1" className="Row-total" id="vesselCommercialTotal" tooltip="Commercial Vessel Fees (Total State &amp; County)" value={vesselCommercialFee} readOnly />

        <input className="no-print" type="checkbox" id="vesselCommercialExempt" data-tooltip="Set Commercial Vessel to Exempt (removes fees)" checked={vesselCommercialExempt} onChange={this.handleClick} />
        <label className="no-print" htmlFor="vesselCommercialExempt">Vessel is Exempt</label>
        <b className="print-label print-only" >Commercial Vessel Fee</b>
        <span className="vesselNote no-print"><b>Note:</b> Vessels owned by non-residents used exclusively for commercial shrimping from Mississippi, North Carolina or Texas can be exempt.</span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vesselCommercialExempt: state.registration.vesselCommercialExempt,
    vesselCommercialFee: state.registration.vesselCommercialFee,
    vesselShowExemptFee: state.registration.vesselShowExemptFee,
  };
};

export default connect(mapStateToProps, { toggleVesselCommercialExempt })(CommercialVesselFee);
